import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/'

import middlewarePipeline from './middlewarePipeline'
import authMiddle from './middleware/auth'

const routes = [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta : {
        navKey : 1
    },
    component: () =>import('../views/DashboardView.vue'),
    children: [{
      path: 'dispatch',
      name: 'dispatch',
      meta : {
        navKey : 1
      },
      component: ()=>import('../views/DispatchView.vue'),
    },
    {
      path: 'casePerson',
      name: 'casePerson',
      meta : {
        navKey : 2
      },
      component: ()=>import('../views/CasePersonView.vue'),
    }, 
    {
      path: 'attendant',
      name: 'attendant',
      meta : {
        navKey : 3
      },
      component: ()=>import('../views/AttendantView.vue'),
    }, 
    {
      path: 'statistics',
      name: 'statistics',
      meta : {
        navKey : 1
      },
      component: ()=>import('../views/StatisticsView.vue'),
    }, 
    {
      path: 'setting',
      name: 'setting',
      meta : {
        navKey : 4
      },
      component: ()=>import('../views/SettingView.vue'),
    }
    ],
    meta: {
      middleware: [
        authMiddle
      ]
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  }
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {

  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

export default router
